/**
 * @generated SignedSource<<4d55aa969e816897d00319e58e9ae80b>>
 * @relayHash 7a459e5b02d70f6bd0fcfe9c6f09aaed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f7439efefbddad3c834c2882c87168c3d526f7ef715c67e6eb50135d0daa5fbe

import type { ConcreteRequest } from 'relay-runtime';
export type useIsDataClassificationEnabledForOrgQuery$variables = Record<PropertyKey, never>;
export type useIsDataClassificationEnabledForOrgQuery$data = {
  readonly isDataClassificationEnabled: boolean | null;
};
export type useIsDataClassificationEnabledForOrgQuery = {
  response: useIsDataClassificationEnabledForOrgQuery$data;
  variables: useIsDataClassificationEnabledForOrgQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "isDataClassificationEnabled"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useIsDataClassificationEnabledForOrgQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useIsDataClassificationEnabledForOrgQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "7a459e5b02d70f6bd0fcfe9c6f09aaed",
    "id": "f7439efefbddad3c834c2882c87168c3d526f7ef715c67e6eb50135d0daa5fbe",
    "metadata": {},
    "name": "useIsDataClassificationEnabledForOrgQuery",
    "operationKind": "query",
    "text": "query useIsDataClassificationEnabledForOrgQuery{isDataClassificationEnabled}"
  }
};
})();

(node as any).hash = "5fefa316f3ebea3d1e92d59f94b250db";

export default node;
